export const initialState = {
  loading: false,
  success: false,
  error: false,
  bets: [],
  bettype: 1,
  stake: 0,
  // userId: 1,
  totalOdds: 0.0,
  possibleWinAmount: 0.0,
  isFastBet: true,
  multiPrice: "",
  NotBetPlaced: false,
  limit: "",
  isFirstTime: true,
  betlimit: {
    maxWinAmount: 400000,
    maxBetAmount: 100000,
    minBetAmount: 50,
    maxBetCount: 20,
    maxOddLimit: 1000,
    minOddLimit: 0
  },
  isTouched: false,
  sponsoredLoading: false,
  serverErrorMsg: "",
  localErrorMsg: false,
  switchToCombo: false,
  sponsoredBetPlaceSuccess: false
};
